import {
  Checkbox as MuiCheckbox,
  FormControlLabel,
  FormControlLabelProps,
} from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

type CustomFormControlLabelProps = Omit<FormControlLabelProps, 'control'>;

export interface CheckboxProps extends CustomFormControlLabelProps {
  className?: string;
  defaultChecked?: boolean;
}

const CheckboxImpl = React.forwardRef<HTMLLabelElement, CheckboxProps>(
  ({ className, defaultChecked, ...props }, ref) => {
    /**
     * This is a workaround to solve the problem that MUI raises
     * when defaultChecked state is changed for uncontrolled component
     * -  component is changing the default value state of an uncontrolled
     * SwitchBase after being initialized.
     */
    const _defaultChecked = React.useRef(defaultChecked);

    return (
      <FormControlLabel
        className={className}
        ref={ref}
        control={<MuiCheckbox defaultChecked={_defaultChecked.current} />}
        {...props}
      />
    );
  }
);

export const Checkbox = muiStyled(CheckboxImpl)(({ theme }) => {
  const { disabledOpacity } = theme.palette.action;
  return css`
    &.MuiFormControlLabel-root {
      /* Ensure checkbox and label are vertically aligned */
      align-items: center;
      margin-left: 0;
      margin-right: 0;

      :hover {
        opacity: 0.8;
      }

      &.Mui-disabled {
        /* override default opacity */
        opacity: ${disabledOpacity};
      }

      .MuiCheckbox-root.Mui-checked {
        color: ${theme.palette.primary.main};
      }

      .MuiFormControlLabel-label {
        color: ${theme.palette.text.primary};
        display: flex;
        align-items: center;
      }
    }
  `;
});

export default Checkbox;
